export const getProfileAPI = "/profile";
export const updateProfileAPI = "/profile";
export const changePasswordAPI = "/change-password";
